import { createSlice } from '@reduxjs/toolkit';
import { update } from 'lodash';

const initialState = {
	firstName: '',
	lastName: '',
	emailId: '',
	phoneNumber: '',
	isAuthenticated: false,
	currentPlanStartDate: '',
	planTierId: '',
	userId: '',
	stripeCustomerId: '',
	profileURL: '',
};

const userDetailsSlice = createSlice({
	name: 'userDetails',
	initialState,
	reducers: {
		updateFirstName: (state, action) => {
			state.firstName = action.payload;
		},
		updateLastName: (state, action) => {
			state.lastName = action.payload;
		},
		updateEmailId: (state, action) => {
			state.emailId = action.payload;
		},
		updatePhoneNumber: (state, action) => {
			state.phoneNumber = action.payload;
		},
		updateIsAuthenticated: (state, action) => {
			state.isAuthenticated = action.payload;
		},
		updateCurrentPlanStartDate: (state, action) => {
			state.currentPlanStartDate = action.payload;
		},
		updatePlanTierId: (state, action) => {
			state.planTierId = action.payload;
		},
		updateUserId: (state, action) => {
			state.userId = action.payload;
		},
		updateStripeCustomerId: (state, action) => {
			state.stripeCustomerId = action.payload;
		},
		updateProfileURL: (state, action) => {
			state.profileURL = action.payload;
		},
	},
});

export const {
	updateFirstName,
	updateLastName,
	updateEmailId,
	updatePhoneNumber,
	updateIsAuthenticated,
	updatePlanTierId,
	updateCurrentPlanStartDate,
	updateUserId,
	updateStripeCustomerId,
	updateProfileURL,
} = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
